import { useTranslation } from 'next-i18next';

import { vacanciesSlugs } from '@boss/constants/corporate-jobs';
import { IIVacancy } from '@boss/types/corporate-jobs';
import { JobBlock } from '@boss/ui';
import { slugify } from '@boss/utils';

import { mapContentfulToNextLocale } from '../../utils/localeMapper';

type B2bProps = {
  jobs: (IIVacancy | null)[];
  locale: string;
  pageTitle: string;
};

const B2b = ({ jobs, locale, pageTitle }: B2bProps) => {
  const { t } = useTranslation(['jobs']);

  return (
    <>
      <div className="h1 my-12">{pageTitle}</div>
      {jobs.length > 0 ? (
        jobs.map((job, index) => {
          const slug = `${vacanciesSlugs[mapContentfulToNextLocale(locale)]}/${slugify(job?.functieTitel ?? '')}/${
            job?.vacatureId
          }`;

          if (job !== null) {
            return (
              <JobBlock
                cta={{
                  alternativeText: null,
                  anchorClassName: '',
                  href: slug,
                  icon: undefined,
                  iconPosition: 'left',
                  label: t('applyButton'),
                  type: 'primary',
                }}
                image={{
                  imageAlt: t('paintDrop'),
                  imageUrl: `/images/paintdrops/${index % 10}.png`,
                  id: job.vacatureId?.toString(),
                }}
                key={job.vacatureId}
                location={job.plaatsTewerkstelling?.locatie}
                title={job.functieTitel}
                variant="b2b"
              />
            );
          }
        })
      ) : (
        <p className="body">{t('noResult')}</p>
      )}
    </>
  );
};

export default B2b;
